export enum VehicleGroupType {
    REPORT = 'REPORT',
    ADS = 'ADS'
}
